import {
    DirectionsBike,
    DirectionsWalk,
    DownhillSkiing,
    ElectricScooter,
    Kitesurfing,
    PedalBike,
    Pool,
    Rowing,
    Skateboarding,
    Surfing,
    Terrain,
    Waves,
} from "@mui/icons-material";

const SPORT_TYPE_ICONS = {
    surf: Surfing,
    skate: Skateboarding,
    snow: DownhillSkiing,
    sls: Pool,
    wake: Kitesurfing,
    skim: Surfing,
    bodyboard: Waves,
    bmx: PedalBike,
    scooter: ElectricScooter,
    paddle: Rowing,
    freeride: Terrain,
    fmb: DirectionsBike,
};

export function SportTypeIcon({ sportType }: { sportType?: string | null }) {
    const Icon =
        SPORT_TYPE_ICONS[sportType as keyof typeof SPORT_TYPE_ICONS] ||
        DirectionsWalk;
    return <Icon fontSize="small" />;
}
